import config from './config'
import { KJUR, b64utoutf8 } from 'jsrsasign';

const {
    REACT_APP_JWT_SECRET_KEY,
    REACT_APP_JWT_ALG
} = config

export const getCurrentYear = () => {
    const todayDate = new Date();
    const year = todayDate.getFullYear();
    return year;
}

export const extractValue = (url) => {
    const regex = /reports\/(.*?)\//;
    const match = url.match(regex);
    return match ? match[1] : null;
};

export const decryptFn = (ciphertext) => {
    return atob(ciphertext)
};

export const handleScrollToTop = () => {
    if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
    }
};

export const controlScrollDynamic = idSelector => {
    const scrollToTopButton = document.querySelector(`.${idSelector}`);
    window.addEventListener('scroll', () => {
        const scrollY = window.scrollY || window.pageYOffset;
        if (scrollY >= 0) {
            scrollToTopButton.style.display = 'block';
            scrollToTopButton.classList.add('fade-in');
        } else {
            scrollToTopButton.style.display = 'none';
            scrollToTopButton.classList.remove('fade-in');
        }
    });
}

export const languages = {
    spanish: 'es',
    english: 'en',
    german: 'de'
}

const {
    spanish,
    english,
    german
} = languages

export const countryToLanguage = {
    'Spain': spanish,
    'Mexico': spanish,
    'Colombia': spanish,
    'Argentina': spanish,
    'Peru': spanish,
    'Venezuela': spanish,
    'Chile': spanish,
    'Guatemala': spanish,
    'Cuba': spanish,
    'Bolivia': spanish,
    'Dominican Republic': spanish,
    'Honduras': spanish,
    'Paraguay': spanish,
    'El Salvador': spanish,
    'Nicaragua': spanish,
    'Costa Rica': spanish,
    'Puerto Rico': spanish,
    'Panama': spanish,
    'Uruguay': spanish,
    'Equatorial Guinea': spanish,
    'Germany': german,
    'Austria': german,
    'Switzerland': german,
    'Luxembourg': german,
    'Liechtenstein': german,
    'Belgium': german
};

export const getLanguageFromCountry = (countryName) => {
    const language = countryToLanguage[countryName];
    if (language) return language
    return english
}

export const createJWT = async (data) => {
    try {
        const alg = REACT_APP_JWT_ALG
        const header = { alg, typ: 'JWT' };
        const expiresIn = 30;
        const exp = Math.floor(Date.now() / 1000) + expiresIn;
        data['exp'] = exp
        const token = KJUR.jws.JWS.sign(
            alg,
            header,
            data,
            { utf8: REACT_APP_JWT_SECRET_KEY }
        );
        const base64 = btoa(token)
        return base64
    } catch (error) {
        console.error('Failed to encode payload:', error)
        throw error
    }
};

export const decodeJWT = async (token) => {
    try {
        if (token) {
            const data = atob(token)
            const decoded = KJUR.jws.JWS.readSafeJSONString(
                b64utoutf8(data.split(".")[1])
            );
            const currentTime = Math.floor(Date.now() / 1000);
            if (currentTime > decoded.exp) {
                throw new Error('Token already expired')
            }
            delete decoded.exp
            return decoded
        }
        return null
    } catch (error) {
        console.error('Failed to decode JWT:', error);
        throw error
    }
};